/*
 *
 * MeasurementCreate actions
 *
 */

import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DESCENDANTS_WATCHER,
  GET_DESCENDANTS_SUCCESS,
  GET_DESCENDANTS_FAILED,
  POST_LOGO_EMAIL_WATCHER,
  POST_LOGO_EMAIL_SUCCESS,
  POST_LOGO_EMAIL_FAILED,
  POST_IMAGE_EMAIL_WATCHER,
  POST_IMAGE_EMAIL_SUCCESS,
  POST_IMAGE_EMAIL_FAILED,
  STEP_ONE_WATCHER,
  STEP_ONE_SUCCESS,
  STEP_ONE_FAILED,
  STEP_MAIL_WATCHER,
  STEP_MAIL_SUCCESS,
  STEP_MAIL_FAILED,
  STEP_RECIPIENTS_WATCHER,
  STEP_RECIPIENTS_SUCCESS,
  STEP_RECIPIENTS_FAILED,
  STEP_DATACHECK_WATCHER,
  STEP_DATACHECK_SUCCESS,
  STEP_DATACHECK_FAILED,
  STEP_PREVIEW_WATCHER,
  STEP_PREVIEW_SUCCESS,
  STEP_PREVIEW_FAILED,
  STEP_SCHEDULE_WATCHER,
  STEP_SCHEDULE_SUCCESS,
  STEP_SCHEDULE_FAILED,
  STEP_COMPLETE_WATCHER,
  STEP_COMPLETE_SUCCESS,
  STEP_COMPLETE_FAILED,
  STEP_TWO_WATCHER,
  STEP_TWO_SUCCESS,
  STEP_TWO_FAILED,
  STEP_THIRD_WATCHER,
  STEP_THIRD_SUCCESS,
  STEP_THIRD_FAILED,
  STEP_FOURTH_WATCHER,
  STEP_FOURTH_SUCCESS,
  STEP_FOURTH_FAILED,
  STEP_FINISH_WATCHER,
  STEP_FINISH_SUCCESS,
  STEP_FINISH_FAILED,
  EDIT_MEASUREMENT_NAME_WATCHER,
  EDIT_MEASUREMENT_NAME_SUCCESS,
  EDIT_MEASUREMENT_NAME_FAILED,
  GET_LEADERS_WATCHER,
  GET_LEADERS_SUCCESS,
  GET_LEADERS_FAILED,
  GET_SURVEYS_TYPE_WATCHER,
  GET_SURVEYS_TYPE_SUCCESS,
  GET_SURVEYS_TYPE_FAILED,
  GET_MEASURE_WATCHER,
  GET_MEASURE_SUCCESS,
  GET_MEASURE_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  GET_ORGANIZATION_SURVEYS_FAILED,
  GET_ORGANIZATION_SURVEYS_SUCCESS,
  GET_SEGMENTS_SURVEYS_WATCHER,
  GET_SEGMENTS_SURVEYS_FAILED,
  GET_SEGMENTS_SURVEYS_SUCCESS,
  UPDATE_MEASURE_WATCHER,
  UPDATE_MEASURE_SUCCESS,
  UPDATE_MEASURE_FAILED,
  FORCE_SAVE_WATCHER,
  FORCE_SAVE_SUCCESS,
  FORCE_SAVE_FAILED,
  GET_EMPLOYEES_BY_SEGMENTS_WATCHER,
  GET_EMPLOYEES_BY_SEGMENTS_SUCCESS,
  GET_EMPLOYEES_BY_SEGMENTS_FAILED,
} from "./constants"

// GET SURVEYS TYPE
export function getSurveysTypeWatcher(payload) {
  return {
    type: GET_SURVEYS_TYPE_WATCHER,
    payload,
  }
}

export function getSurveysTypeSuccess(payload) {
  return {
    type: GET_SURVEYS_TYPE_SUCCESS,
    payload,
  }
}

export function getSurveysTypeFailed(payload) {
  return {
    type: GET_SURVEYS_TYPE_FAILED,
    payload,
  }
}

// GET LEADERS
export function getLeadersWatcher(payload) {
  return {
    type: GET_LEADERS_WATCHER,
    payload,
  }
}

export function getLeadersSuccess(payload) {
  return {
    type: GET_LEADERS_SUCCESS,
    payload,
  }
}

export function getLeadersFailed(payload) {
  return {
    type: GET_LEADERS_FAILED,
    payload,
  }
}

// EDIT MEASUREMENT NAME
export function editMeasurementNameWatcher(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_WATCHER,
    payload,
  }
}

export function editMeasurementNameSuccess(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_SUCCESS,
    payload,
  }
}

export function editMeasurementNameFailed(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_FAILED,
    payload,
  }
}

// STEP FINISH
export function stepFinishWatcher(payload) {
  return {
    type: STEP_FINISH_WATCHER,
    payload,
  }
}

export function stepFinishSuccess(payload) {
  return {
    type: STEP_FINISH_SUCCESS,
    payload,
  }
}

export function stepFinishFailed(payload) {
  return {
    type: STEP_FINISH_FAILED,
    payload,
  }
}

// STEP FOURTH
export function stepFourthWatcher(payload) {
  return {
    type: STEP_FOURTH_WATCHER,
    payload,
  }
}

export function stepFourthSuccess(payload) {
  return {
    type: STEP_FOURTH_SUCCESS,
    payload,
  }
}

export function stepFourthFailed(payload) {
  return {
    type: STEP_FOURTH_FAILED,
    payload,
  }
}

// STEP THIRD
export function stepThirdWatcher(payload) {
  return {
    type: STEP_THIRD_WATCHER,
    payload,
  }
}

export function stepThirdSuccess(payload) {
  return {
    type: STEP_THIRD_SUCCESS,
    payload,
  }
}

export function stepThirdFailed(payload) {
  return {
    type: STEP_THIRD_FAILED,
    payload,
  }
}

// STEP TWO
export function stepTwoWatcher(payload) {
  return {
    type: STEP_TWO_WATCHER,
    payload,
  }
}

export function stepTwoSuccess(payload) {
  return {
    type: STEP_TWO_SUCCESS,
    payload,
  }
}

export function stepTwoFailed(payload) {
  return {
    type: STEP_TWO_FAILED,
    payload,
  }
}

// STEP ONE
export function stepOneWatcher(payload) {
  return {
    type: STEP_ONE_WATCHER,
    payload,
  }
}

export function stepOneSuccess(payload) {
  return {
    type: STEP_ONE_SUCCESS,
    payload,
  }
}

export function stepOneFailed(payload) {
  return {
    type: STEP_ONE_FAILED,
    payload,
  }
}

// MAIL STEP

export function stepMailWatcher(payload) {
  return {
    type: STEP_MAIL_WATCHER,
    payload,
  }
}

export function stepMailSuccess(payload) {
  return {
    type: STEP_MAIL_SUCCESS,
    payload,
  }
}

export function stepMailFailed(payload) {
  return {
    type: STEP_MAIL_FAILED,
    payload,
  }
}

// step recipients

export function stepRecipientsWatcher(payload) {
  return {
    type: STEP_RECIPIENTS_WATCHER,
    payload,
  }
}

export function stepRecipientsSuccess(payload) {
  return {
    type: STEP_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function stepRecipientsFailed(payload) {
  return {
    type: STEP_RECIPIENTS_FAILED,
    payload,
  }
}

// step datacheck

export function stepDatacheckWatcher(payload) {
  return {
    type: STEP_DATACHECK_WATCHER,
    payload,
  }
}

export function stepDatacheckSuccess(payload) {
  return {
    type: STEP_DATACHECK_SUCCESS,
    payload,
  }
}

export function stepDatacheckFailed(payload) {
  return {
    type: STEP_DATACHECK_FAILED,
    payload,
  }
}

// step preview
export function stepPreviewWatcher(payload) {
  return {
    type: STEP_PREVIEW_WATCHER,
    payload,
  }
}

export function stepPreviewSuccess(payload) {
  return {
    type: STEP_PREVIEW_SUCCESS,
    payload,
  }
}

export function stepPreviewFailed(payload) {
  return {
    type: STEP_PREVIEW_FAILED,
    payload,
  }
}

// step schedule
export function stepScheduleWatcher(payload) {
  return {
    type: STEP_SCHEDULE_WATCHER,
    payload,
  }
}

export function stepScheduleSuccess(payload) {
  return {
    type: STEP_SCHEDULE_SUCCESS,
    payload,
  }
}

export function stepScheduleFailed(payload) {
  return {
    type: STEP_SCHEDULE_FAILED,
    payload,
  }
}

// step complete
export function stepCompleteWatcher(payload) {
  return {
    type: STEP_COMPLETE_WATCHER,
    payload,
  }
}

export function stepCompleteSuccess(payload) {
  return {
    type: STEP_COMPLETE_SUCCESS,
    payload,
  }
}

export function stepCompleteFailed(payload) {
  return {
    type: STEP_COMPLETE_FAILED,
    payload,
  }
}

export function forceSaveWatcher(payload) {
  return {
    type: FORCE_SAVE_WATCHER,
    payload,
  }
}

export function forceSaveSuccess(payload) {
  return {
    type: FORCE_SAVE_SUCCESS,
    payload,
  }
}

export function forceSaveFailed(payload) {
  return {
    type: FORCE_SAVE_FAILED,
    payload,
  }
}

// get employees by segments

export function getEmployeesBySegmentsWatcher(payload) {
  return {
    type: GET_EMPLOYEES_BY_SEGMENTS_WATCHER,
    payload,
  }
}

export function getEmployeesBySegmentsSuccess(payload) {
  return {
    type: GET_EMPLOYEES_BY_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getEmployeesBySegmentsFailed(payload) {
  return {
    type: GET_EMPLOYEES_BY_SEGMENTS_FAILED,
    payload,
  }
}

// POST IMAGE EMAIL
export const postImageEmailWatcher = (payload) => {
  return {
    type: POST_IMAGE_EMAIL_WATCHER,
    payload,
  }
}

export function postImageEmailSuccess(payload) {
  return {
    type: POST_IMAGE_EMAIL_SUCCESS,
    payload,
  }
}

export function postImageEmailFailed(payload) {
  return {
    type: POST_IMAGE_EMAIL_FAILED,
    payload,
  }
}

// POST LOGO EMAIL
export const postLogoEmailWatcher = (payload) => {
  return {
    type: POST_LOGO_EMAIL_WATCHER,
    payload,
  }
}

export function postLogoEmailSuccess(payload) {
  return {
    type: POST_LOGO_EMAIL_SUCCESS,
    payload,
  }
}

export function postLogoEmailFailed(payload) {
  return {
    type: POST_LOGO_EMAIL_FAILED,
    payload,
  }
}

// GET DESCENDANTS
export const getDescendantsWatcher = (payload) => {
  return {
    type: GET_DESCENDANTS_WATCHER,
    payload,
  }
}

export function getDescendantsSuccess(payload) {
  return {
    type: GET_DESCENDANTS_SUCCESS,
    payload,
  }
}

export function getDescendantsFailed(payload) {
  return {
    type: GET_DESCENDANTS_FAILED,
    payload,
  }
}

// GET DIVISIONS
export const getDivisionsWatcher = (payload) => {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed(payload) {
  return {
    type: GET_DIVISIONS_FAILED,
    payload,
  }
}

// new options

export function getMeasureWatcher(payload) {
  return {
    type: GET_MEASURE_WATCHER,
    payload,
  }
}

export function getMeasureSuccess(payload) {
  return {
    type: GET_MEASURE_SUCCESS,
    payload,
  }
}

export function getMeasureFailed(payload) {
  return {
    type: GET_MEASURE_FAILED,
    payload,
  }
}

export function updateMeasureWatcher(payload) {
  return {
    type: UPDATE_MEASURE_WATCHER,
    payload,
  }
}

export function updateMeasureSuccess(payload) {
  return {
    type: UPDATE_MEASURE_SUCCESS,
    payload,
  }
}

export function updateMeasureFailed(payload) {
  return {
    type: UPDATE_MEASURE_FAILED,
    payload,
  }
}

export function getSegmentsWatcher(payload) {
  return {
    type: GET_SEGMENTS_WATCHER,
    payload,
  }
}

export function getSegmentsSuccess(payload) {
  return {
    type: GET_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getSegmentsFailed(payload) {
  return {
    type: GET_SEGMENTS_FAILED,
    payload,
  }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}

export function getScopeTypesWatcher(payload) {
  return {
    type: GET_SCOPE_TYPES_WATCHER,
    payload,
  }
}

export function getScopeTypesSuccess(payload) {
  return {
    type: GET_SCOPE_TYPES_SUCCESS,
    payload,
  }
}

export function getScopeTypesFailed(payload) {
  return {
    type: GET_SCOPE_TYPES_FAILED,
    payload,
  }
}

export function getOrganizationSurveysWatcher(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_WATCHER,
    payload,
  }
}

export function getOrganizationSurveysSuccess(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_SUCCESS,
    payload,
  }
}

export function getOrganizationSurveysFailed(payload) {
  return {
    type: GET_ORGANIZATION_SURVEYS_FAILED,
    payload,
  }
}

export function getSegmentsSurveysWatcher(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_WATCHER,
    payload,
  }
}

export function getSegmentsSurveysSuccess(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_SUCCESS,
    payload,
  }
}

export function getSegmentsSurveysFailed(payload) {
  return {
    type: GET_SEGMENTS_SURVEYS_FAILED,
    payload,
  }
}
